// extracted by mini-css-extract-plugin
export default {"studentAlertsWrapper":"StudentAlertsWrapper__studentAlertsWrapper___XmCeJ","textEllipsis":"StudentAlertsWrapper__textEllipsis___gwZkD"};